<template>
  <div v-if="video || items.length">
    <div class="position-relative">
      <v-sheet v-if="video" class="video-hero-section" color="grey lighten-2">
        <video :src="files + video" autoplay muted></video>
      </v-sheet>

      <CarouselWidget
        v-else-if="items.length"
        class="slide-show-section"
        :items="items"
        :itemsToShow="{
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 1,
        }"
        :gap="0"
        nav-inside
        nav
      >
        <template #item="{ item }">
          <v-card v-bind="getLinkAttrs(item.link, server)" flat tile>
            <img
              :src="
                files +
                (xsOnly && item.mobile
                  ? item.mobile + '?resize=1&w=600'
                  : item.desktop + '?resize=1&w=1920')
              "
              class="slide-show-section_img d-block"
              alt="Hero Image"
              width="100%"
            />
          </v-card>
        </template>
      </CarouselWidget>

      <div class="search">
        <SearchWidget />
      </div>
    </div>

    <template v-if="smAndDown">
      <v-dialog v-model="dialog" persistent max-width="500">
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex justify-center">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="text-body-1 text-none text-uppercase font-weight-medium"
              color="primary"
              depressed
              block
              large
              tile
            >
              Buscar Imóveis
              <v-icon size="16" right> fa-search </v-icon>
            </v-btn>
          </div>
        </template>

        <v-card class="pa-4">
          <v-btn
            @click="dialog = false"
            class="search-close-button"
            color="primary"
            depressed
            x-small
            fab
          >
            <v-icon color="white"> fa-times </v-icon>
          </v-btn>

          <TitleWidget small>Buscar Imóveis</TitleWidget>

          <SearchHomeForm class="mt-4" />
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import SearchWidget from "../widgets/SearchWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import SearchHomeForm from "../forms/SearchHomeForm.vue";
import { getLinkAttrs } from "../../utils/getLinkAttrs";

const _config = {
  mod: "slides",
};

const _data = {
  dialog: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest("hero-video").item;
    },
    video() {
      const item = this.item;
      if (item.mobile && this.xsOnly) return item.mobile;

      return item.desktop;
    },
    items() {
      return this.$rest(_config.mod).list.filter(({ desktop }) => !!desktop);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getLinkAttrs,
  },
  beforeCreate() {
    this.$rest("hero-video").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest(_config.mod).get();
  },
  components: {
    CarouselWidget,
    SearchWidget,
    TitleWidget,
    SearchHomeForm,
  },
};
</script>

<style lang="scss" scoped>
.slide-show-section {
  &_img {
    aspect-ratio: 1920 / 680;
    height: 100%;
    object-fit: cover;
    width: 100%;

    @media screen and (max-width: 600px) {
      aspect-ratio: 600 / 600;
    }
  }
}

.video-hero-section::v-deep {
  aspect-ratio: 1920 / 680;

  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }

  video {
    display: block;
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}

.search {
  bottom: 48px;
  left: 0;
  position: absolute;
  right: 0;

  @media screen and (max-width: 1279.9px) {
    bottom: 20px;
  }
}

.search-close-button {
  position: absolute;
  right: 16px;
  top: 5px;
}
</style>
